import React from 'react';
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import Swal from 'sweetalert2';

interface CTAButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
  href?: string;
  target?: string;
  calendlyUrl?: string;
  icon?: boolean;
  variant?: string;
  isWebinarRegistration?: boolean;
}

const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  className = '',
  onClick,
  href,
  target,
  calendlyUrl,
  icon = true,
  variant = 'default',
  isWebinarRegistration = false
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (isWebinarRegistration && calendlyUrl) {
      // Redirect directly to Razorpay payment for webinar registration
      window.open('https://rzp.io/rzp/are-webinar-india', '_blank');
    } else if (calendlyUrl) {
      window.open(calendlyUrl, '_blank');
    } else if (href) {
      if (target === '_blank') {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
    } else {
      // Default action: navigate to booking page
      navigate('/booking');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`
        inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200 transform hover:scale-105
        ${className}
      `}
    >
      {text}
    </button>
  );
};

export default CTAButton;